import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { EditableRolePermissions } from "@/features/organization-roles/EditableRolePermissions";
import { SearchableRolePermissionsList } from "@/features/organization-roles/SearchableRolePermissionsList";
import { authQueryOptions } from "@/services/auth";
import { organizationQueryOptions } from "@/services/organization";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/roles/(roles)/$roleId/permissions",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const params = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/roles/(roles)/$roleId/permissions",
	});

	const {
		data: role,
		isLoading,
		isError: hasError,
	} = useQuery(
		organizationQueryOptions.systemOrganizationRoles.detail(params.roleId),
	);
	const canUpdateQuery = useQuery({
		...authQueryOptions.checkAction({
			name: "UpdateOrganizationRole",
			entityType: "OrganizationRole",
			entityId: params.roleId,
		}),
		enabled: role?.custom === true && role.adminRole !== true,
	});
	const canEditPermissions =
		role?.custom === true &&
		role.adminRole !== true &&
		canUpdateQuery.data === true;
	const catalogQuery = useQuery({
		...organizationQueryOptions.permissions.list(),
		enabled: canEditPermissions,
	});

	if (canEditPermissions && role && catalogQuery.isError) {
		return (
			<SearchableRolePermissionsList
				permissions={[]}
				isLoading={false}
				hasError
			/>
		);
	}

	if (canEditPermissions && role) {
		return (
			<EditableRolePermissions
				organizationId={params.orgId}
				role={role}
				permissions={catalogQuery.data ?? []}
				isLoading={catalogQuery.isLoading}
			/>
		);
	}

	return (
		<SearchableRolePermissionsList
			permissions={role?.permissions ?? []}
			isLoading={isLoading}
			hasError={hasError}
			isAdminRole={role?.adminRole}
		/>
	);
}
